import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { badgeText } from '../../utils/inboxUnread';

/** A red count bubble for something unread; nothing when the count is 0. */
export function UnreadBadge({ count, testID }: { count: number; testID?: string }) {
  if (count <= 0) return null;
  return (
    <View style={styles.badge} testID={testID}>
      <Text style={styles.text}>{badgeText(count)}</Text>
    </View>
  );
}

/** The light highlight on a tab holding new items, until the parent opens it. */
export const UNREAD_TAB = { backgroundColor: '#FFF7ED', borderColor: '#FDBA74' };
export const UNREAD_TAB_TEXT = { color: '#C2410C' };

const styles = StyleSheet.create({
  badge: {
    minWidth: 18,
    height: 18,
    paddingHorizontal: 5,
    borderRadius: 9,
    backgroundColor: '#DC2626',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 6,
  },
  text: { color: '#FFFFFF', fontSize: 10.5, fontWeight: '800' },
});
